export default __webpack_public_path__ + "static/media/review-on-google-min.cf696574.png";